<script>
    export let message;
  </script>
  
  <div class="message {message.type}">
    {message.text}
  </div>